import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const feraProductReviewsWidget: ComponentTemplate = {
  id: "57af6f43-4724-4ab3-8702-bc47b0f19cab",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Fera Product Reviews",
  leftBarCategory: { main: "productIntegrations", subCategory: "fera" },
  tags: ["widget"],
  preview: "integrations/fera-product-reviews.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  template: {
    id: "$uid",
    type: "feraProductReviewsWidget",
    props: { style: { alignSelf: "stretch" } },
  },
};
